import { ActiveMask, FlexInner, StyledSwitch, SwitchOption } from "./styled"

export interface ISwitchOption {
  label: string
  value: string
}

const DarkSwitch = ({
  options,
  value,
  onChange,
  optionWidth = 77,
  disabled = false,
}: {
  options: [ISwitchOption, ISwitchOption]
  value: string
  onChange: (value: string) => void
  optionWidth?: number
  disabled?: boolean
}) => {
  const activeIndex = options.findIndex((option) => option.value === value)
  const nextValue = activeIndex === 0 ? options[1].value : options[0].value
  return (
    <StyledSwitch>
      <FlexInner>
        <ActiveMask $width={optionWidth} $activeIndex={activeIndex} />

        {options.map((option, optionIndex) => (
          <SwitchOption
            $disabled={disabled}
            $width={optionWidth}
            $isActive={activeIndex === optionIndex}
            key={option.value}
            onClick={() => {
              if (!disabled) {
                onChange(nextValue)
              }
            }}
          >
            {option.label}
          </SwitchOption>
        ))}
      </FlexInner>
    </StyledSwitch>
  )
}

export default DarkSwitch
